module.exports = __webpack_public_path__ + "media/images/application/template/plus-74adef6528b29f649a80318494876fef.svg";